import { render, staticRenderFns } from "./index.vue?vue&type=template&id=34b6cfba&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=34b6cfba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b6cfba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34b6cfba')) {
      api.createRecord('34b6cfba', component.options)
    } else {
      api.reload('34b6cfba', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=34b6cfba&scoped=true&", function () {
      api.rerender('34b6cfba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/page_price_versions/components/UnionActivity/index.vue"
export default component.exports